import type { ServicePeriodHistory } from '../types/servicePeriod'
import { expiredAnchorPeriod, needsExpiredAnchorPeriod } from '../utils/expiredAnchorPeriod'

export function useExpiredAnchorPeriod(getService: () => userServicesAttributes | null | undefined) {
  const key = computed(() => {
    const service = getService()
    return `expiredAnchorPeriod-${JSON.stringify([
      service?.user_id, service?.id, service?.plan_id, service?.status, service?.billing_mode,
      service?.period_start, service?.period_end, service?.updated_at,
      service?.extra?.buy_time, service?.extra?.buy_length,
    ])}`
  })
  const { data, status, error } = useLazyAsyncData(key, async () => {
    const service = getService()
    const serviceKey = key.value
    if (!service || !needsExpiredAnchorPeriod(service)) return { serviceKey, period: null }
    const history = await useAPI().get(`users/${service.user_id}/services/${service.id}/billing_periods`, {
      params: { limit: 1 },
    }) as ServicePeriodHistory
    return { serviceKey, period: expiredAnchorPeriod(service, history) }
  })
  return {
    period: computed(() => status.value === 'success' && data.value?.serviceKey === key.value ? data.value.period : null),
    pending: computed(() => needsExpiredAnchorPeriod(getService()) && (status.value === 'idle' || status.value === 'pending')),
    error: computed(() => needsExpiredAnchorPeriod(getService()) ? error.value : null),
  }
}
